const today = new Date();
const minDate = new Date(
  today.getFullYear() - 5,
  today.getMonth(),
  today.getDate()
);
const maxDate = new Date(
  today.getFullYear() + 5,
  today.getMonth(),
  today.getDate()
);

const pad2 = (n) => String(n).padStart(2, "0");

export const isValidMDY = (s) => {
  if (!s) return false;
  const m = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (!m) return false;
  const mm = +m[1],
    dd = +m[2],
    yyyy = +m[3];
  const d = new Date(yyyy, mm - 1, dd);
  return (
    d.getFullYear() === yyyy && d.getMonth() === mm - 1 && d.getDate() === dd
  );
};

export const parseMDY = (s) => {
  if (!isValidMDY(s)) return null;
  const [mm, dd, yyyy] = s.split("/").map((v) => +v);
  return new Date(yyyy, mm - 1, dd);
};

export const toMDY = (value) => {
  if (!value) return "";
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [y, m, d] = value.split("-").map(Number);
    return `${pad2(m)}/${pad2(d)}/${y}`;
  }
  if (isValidMDY(value)) return value;
  const d = new Date(value);
  if (!Number.isNaN(d.getTime())) {
    return `${pad2(d.getMonth() + 1)}/${pad2(d.getDate())}/${d.getFullYear()}`;
  }
  return "";
};

export const serviceProviderValidation = {
  name: "serviceProvider",
  label: "Service Provider (Lessor/Landlord)",
  type: "text",
  id: "serviceProvider",
  className: "input",
  placeholder: "",
  columns: "35",
  validation: {
    required: {
      value: true,
      message: "required",
    },
    maxLength: {
      value: 80,
      message: "80 characters max",
    },
  },
};

export const commonNameValidation = {
  name: "commonName",
  label: "Common/Branded Name",
  type: "text",
  id: "commonName",
  className: "input",
  placeholder: "",
  columns: "35",
  validation: {
    required: {
      value: false,
      message: "required",
    },
    maxLength: {
      value: 80,
      message: "80 characters max",
    },
  },
};

export const locationAddressValidation = {
  name: "locationAddress",
  label: "Location Address",
  type: "text",
  id: "locationAddress",
  className: "input",
  placeholder: "",
  columns: "35",
  validation: {
    required: {
      value: true,
      message: "required",
    },
    maxLength: {
      value: 80,
      message: "80 characters max",
    },
    minLength: {
      value: 8,
      message: "Please enter a valid address",
    },
  },
};

export const cityValidation = {
  name: "city",
  label: "City",
  type: "text",
  id: "city",
  className: "input",
  placeholder: "",
  columns: "35",
  validation: {
    required: {
      value: true,
      message: "required",
    },
    maxLength: {
      value: 30,
      message: "30 characters max",
    },
  },
};

export const stateValidation = {
  name: "state",
  label: "State",
  id: "state",
  type: "select",
  placeholder: "Select state",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
};

export const zipcodeValidation = {
  name: "zipcode",
  label: "Zip",
  type: "text",
  id: "zipcode",
  className: "input",
  placeholder: "",
  columns: "35",
  validation: {
    required: true,
    pattern: { value: "[0-9]{5}", message: "Please enter 5 digit zipcode" },
  },
};

export const sqftLeasedValidation = {
  name: "sqftLeased",
  label: "Square Feet Leased",
  type: "number",
  id: "sqftLeased",
  placeholder: "",
  validation: {
    required: {
      value: true,
      message: "required",
    },
    min: {
      value: 1,
      message: "Please select a value between 1 and 9,999",
    },
    max: {
      value: 9999,
      message: "Please select a value between 1 and 9,999",
    },
  },
};

export const termValidation = {
  name: "term",
  label: "Expected Term",
  id: "term",
  type: "select",
  placeholder: "Select term",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
};

export const desksValidation = {
  name: "desks",
  label: "Number of Desks/Workstations in the Leased Space",
  type: "number",
  id: "desks",
  placeholder: "",
  validation: {
    required: {
      value: true,
      message: "required",
    },
    min: {
      value: 1,
      message: "Please select a value between 1 and 99",
    },
    max: {
      value: 99,
      message: "Please select a value between 1 and 99",
    },
  },
};

export const propertyTypeValidation = {
  name: "propertyType",
  type: "radio",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
};

export const spaceTypeValidation = {
  name: "spaceType",
  label: "Space Type",
  id: "spaceType",
  type: "select",
  placeholder: "Select space type",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
};

export const settingTypeValidation = {
  name: "settingType",
  label: "Setting",
  id: "settingType",
  type: "select",
  placeholder: "Select space setting",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
};

export const facilityValidation = {
  name: "facility",
  label: "Facilities",
  id: "facility",
  type: "multiselect",
  placeholder: "Select provided facilities",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
};

export const utilityValidation = {
  name: "utility",
  label: "Utilities",
  id: "utility",
  type: "multiselect",
  placeholder: "Select provided utilities",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
};

export const amenityValidation = {
  name: "amenity",
  label: "Amenities",
  id: "amenity",
  type: "multiselect",
  placeholder: "Select provided amenities",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
};

export const descriptionValidation = {
  name: "description",
  label: "Additional Description",
  id: "description",
  className: "input",
  type: "textarea",
  columns: "35",
  rows: "2",
  placeholder: "",
  validation: {
    required: {
      value: false,
      message: "required",
    },
    maxLength: {
      value: 3000,
      message: "3000 characters max",
    },
  },
};

export const startDateValidation = {
  name: "startDate",
  label: "Expected Start Date",
  type: "text", // <-- text, not "date"
  id: "startDate",
  className: "input",
  placeholder: "MM/DD/YYYY",
  validation: {
    // Not required => allows ongoing leases if left blank
    required: { value: false, message: "required" },
    maxLength: { value: 10, message: "Use MM/DD/YYYY" },
    pattern: {
      value: /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/,
      message: "Enter date as MM/DD/YYYY",
    },
    validate: {
      // allow blank; if present, must be a real calendar date
      calendar: (v) => !v || isValidMDY(v) || "Enter a real date (MM/DD/YYYY)",
      range: (v) => {
        if (!v || !isValidMDY(v)) return true;
        const d = parseMDY(v);
        return (
          (d >= minDate && d <= maxDate) ||
          `Date must be between 01/01/${minDate.getFullYear()} and ${
            "12/31/" + maxDate.getFullYear()
          }`
        );
      },
    },
  },
};

export const agreeToTermsValidation = {
  name: "termsCheck",
  label: "",
  id: "termsCheck",
  type: "checkbox",
  placeholder: "",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
};

//
//
//
//Old Validations
//
//
//
//
//
//

export const fNameValidation = {
  name: "fName",
  label: "First Name",
  type: "text",
  id: "fName",
  className: "input",
  placeholder: "First name",
  columns: "35",
  validation: {
    required: {
      value: true,
      message: "required",
    },
    maxLength: {
      value: 30,
      message: "30 characters max",
    },
  },
};

export const lNameValidation = {
  name: "lName",
  label: "Last Name",
  type: "text",
  id: "lName",
  className: "input",
  placeholder: "Last name",
  validation: {
    required: {
      value: true,
      message: "required",
    },
    maxLength: {
      value: 30,
      message: "30 characters max",
    },
  },
};

export const passwordValidation = {
  name: "password",
  label: "Password",
  type: "password",
  id: "password",
  placeholder: "Password must be at least 8 characters",
  validation: {
    required: {
      value: true,
      message: "required",
    },
    pattern: {
      value:
        /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,30}$/,
      message:
        "password must contain at least 8 characters, one lowercase letter, one uppercase letter, one numeric digit, and one special character",
    },
  },
};

export const emailValidation = {
  name: "email",
  label: "Email",
  type: "email",
  id: "email",
  placeholder: "Your email address",
  validation: {
    required: {
      value: true,
      message: "required",
    },
    pattern: {
      value:
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      message: "enter a valid email address",
    },
  },
};

export const minrcYearValidation = {
  name: "minrcYear",
  label: "MINRC Cohort Year",
  type: "number",
  id: "minrcYear",
  placeholder: "YYYY",
  validation: {
    required: {
      value: true,
      message: "required",
    },
    min: {
      value: 2007,
      message: "Select a year between 2007 and 2024",
    },
    max: {
      value: 2024,
      message: "Select a year between 2007 and 2024",
    },
  },
};

export const applicantLocationValidation = {
  name: "location",
  label: "Current Location",
  id: "location",
  type: "select",
  placeholder: "Select your state",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
};

export const educationValidation = {
  name: "education",
  label: "Highest Level of Completed Education",
  id: "education",
  type: "select",
  placeholder: "Select education",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
};

export const applicantAoisValidation = {
  name: "applicantAois",
  label: "Related Areas of Interest",
  id: "applicantAois",
  type: "multiselect",
  placeholder: "Select up to 5 areas of interest",
  max: 5,
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
};

export const applicantSkillsValidation = {
  name: "applicantSkills",
  label: "Skills",
  id: "applicantSkills",
  type: "multiselect",
  placeholder: "Select up to 5 skills",
  max: 5,
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
};

export const professionalSummaryValidation = {
  name: "professionalSummary",
  label: "Professional Summary",
  id: "professionalSummary",
  className: "input",
  type: "textarea",
  columns: "35",
  rows: "5",
  placeholder: "A 3-5 sentence professional summary",
  validation: {
    required: {
      value: true,
      message: "required",
    },
    maxLength: {
      value: 3000,
      message: "3000 characters max",
    },
  },
};

export const titleValidation = {
  name: "title",
  label: "Title",
  type: "text",
  id: "title",
  className: "input",
  placeholder: "Job title",
  validation: {
    required: {
      value: true,
      message: "required",
    },
    maxLength: {
      value: 30,
      message: "30 characters max",
    },
  },
};

export const dueDateValidation = {
  name: "dueDate",
  label: "Application Due Date",
  type: "text",
  id: "dueDate",
  className: "input",
  placeholder: "Date application is due",
  validation: {
    required: {
      value: true,
      message: "required",
    },
    maxLength: {
      value: 30,
      message: "30 characters max",
    },
  },
};

export const summaryValidation = {
  name: "summary",
  label: "Summary",
  id: "summary",
  className: "input",
  type: "textarea",
  columns: "35",
  rows: "5",
  placeholder:
    "A short summary of the position. This is shown on applicants home view only. Pressing 'Enter' (new line) starts a new paragraph when posting is viewed.",
  validation: {
    required: {
      value: true,
      message: "required",
    },
    maxLength: {
      value: 3000,
      message: "3000 characters max",
    },
  },
};

export const locationsValidation = {
  name: "locations",
  label: "Locations",
  id: "locations",
  type: "multiselect",
  placeholder: "Locations position is available",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
};

export const remoteValidation = {
  name: "remote",
  label: "Remote available?",
  id: "remote",
  type: "checkbox",
  placeholder: "",
};

export const aoisValidation = {
  name: "aois",
  label: "Related Areas of Interest",
  id: "aois",
  type: "multiselect",
  placeholder: "Select areas related to position",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
};

export const skillsValidation = {
  name: "skills",
  label: "Preferred Skills",
  id: "skills",
  type: "multiselect",
  placeholder: "Select preferred skills",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
};

export const typeValidation = {
  name: "type",
  label: "Employment Type",
  id: "type",
  type: "select",
  placeholder: "Select type",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
};

export const agencyValidation = {
  name: "agency",
  label: "Agency",
  type: "text",
  id: "agency",
  className: "input",
  placeholder: "Hiring agency",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
};

export const salaryValidation = {
  name: "salary",
  label: "Salary",
  type: "text",
  id: "salary",
  className: "input",
  placeholder: "Enter position salary",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
};

// export const startDateValidation = {
//   name: "startDate",
//   label: "Position Start Date",
//   type: "date",
//   id: "startDate",
//   className: "input",
//   placeholder: "mm/dd/yyyy",
//   validation: {
//     required: {
//       value: true,
//       message: "required",
//     },
//   },
// };

export const endDateValidation = {
  name: "endDate",
  label: "Position End Date",
  type: "date",
  id: "endDate",
  className: "input",
  placeholder: "mm/dd/yyyy",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
};

// export const descriptionValidation = {
//   name: "description",
//   label: "Position Description",
//   type: "textarea",
//   id: "description",
//   columns: "35",
//   rows: "8",
//   placeholder:
//     "Full position description. The description is only shown when an applicant views detailed job page. To start new paragraphs press 'Enter' (new line).",
//   className: "text-input",
//   validation: {
//     required: {
//       value: true,
//       message: "required",
//     },
//     maxLength: {
//       value: 3000,
//       message: "3000 characters max",
//     },
//   },
// };

export const responsibilitiesValidation = {
  name: "responsibilities",
  label: "Responsibilities",
  type: "textarea",
  id: "responsibilities",
  columns: "35",
  rows: "5",
  placeholder:
    "Core responsibilities of the position. Pressing 'Enter' (new line) starts a new bullet point when viewed in job posting.",
  className: "text-input",
  validation: {
    maxLength: {
      value: 3000,
      message: "3000 characters max",
    },
  },
};

export const qualificationsValidation = {
  name: "qualifications",
  label: "Qualifications",
  type: "textarea",
  id: "qualifications",
  columns: "35",
  rows: "5",
  placeholder:
    "Additional qualifications that would help a candidate stand out. Pressing 'Enter' (new line) starts a new bullet point when viewed in job posting.",
  className: "text-input",
  validation: {
    maxLength: {
      value: 3000,
      message: "3000 characters max",
    },
  },
};

export const websiteValidation = {
  name: "website",
  label: "Website",
  type: "url",
  id: "website",
  placeholder: "Website for applicants to learn more",
  validation: {
    pattern: {
      value:
        /^(https?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(\:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(\#[-a-z\d_]*)?$/i,
      message: "please enter a valid URL",
    },
  },
};

export const hiringNameValidation = {
  name: "hiringName",
  label: "Direct Hiring Contact Name",
  type: "text",
  id: "hiringName",
  className: "input",
  placeholder: "Contact Name",
  validation: {
    maxLength: {
      value: 30,
      message: "30 characters max",
    },
    minLength: {
      value: 2,
      message: "must be at least 2 characters",
    },
  },
};

export const hiringEmailValidation = {
  name: "hiringEmail",
  label: "Direct Hiring Email",
  type: "email",
  id: "hiringEmail",
  placeholder: "Contact email address",
  validation: {
    pattern: {
      value:
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      message: "please enter a valid email address",
    },
  },
};

export const hiringPhoneValidation = {
  name: "hiringNumber",
  label: "Direct Hiring Phone",
  type: "tel",
  id: "hiringNumber",
  placeholder: "Contact phone number",
  validation: {
    pattern: {
      value:
        /(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]‌​)\s*)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)([2-9]1[02-9]‌​|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})\s*(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+)\s*)?$/i,
      message: "please enter a valid phone number",
    },
  },
};

export const agencyNameValidation = {
  name: "agencyName",
  label: "Agency",
  type: "text",
  id: "agencyName",
  className: "input",
  placeholder: "Agency name",
  columns: "35",
  validation: {
    required: {
      value: true,
      message: "required",
    },
    maxLength: {
      value: 60,
      message: "60 characters max",
    },
  },
};

export const agencyEmailValidation = {
  name: "agencyEmail",
  label: "Agency Email",
  type: "text",
  id: "agencyEmail",
  className: "input",
  placeholder: "Agency email address",
  columns: "35",
  validation: {
    required: {
      value: true,
      message: "required",
    },
    pattern: {
      value:
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      message: "enter a valid email address",
    },
  },
};

export const agencyLocationValidation = {
  name: "location",
  label: "Agency Location",
  id: "location",
  type: "select",
  placeholder: "Select your state",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
};
